import styled from 'styled-components';

import colors from 'themes/Main';

import BarEffect from './bar-effect.png';

const { white, darkBlue, gradient, gray02, gray04 } = colors;

export const Container = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const Label = styled.p`
  margin-bottom: 0;
  color: ${darkBlue};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
`;

export const Counter = styled.span`
  color: ${gray02};
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
`;

export const Progress = styled.div`
  position: relative;
  width: 100%;
  height: 10px;
  background-color: ${gray04};
  background-image: url(${BarEffect});
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ width }) => `${width}%`};
  height: 100%;
  background: ${gradient};
  transition: width 0.5s linear;
`;
